"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _contentWidthNarrow = _interopRequireDefault(require("@atlaskit/icon/core/content-width-narrow"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorMediaCenterIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2m0 12h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h12a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1"/></svg>`
}, props, {
  newIcon: _contentWidthNarrow.default
}));
EditorMediaCenterIcon.displayName = 'EditorMediaCenterIcon';
var _default = exports.default = EditorMediaCenterIcon;